<template>
  <div class="row mt-5 justify-content-between">
    <div class="col-sm-5" v-if="checkForPermission(add_sales_profile_comment_permission)">
      <form @submit.prevent="addComment">
        <label>Add Comment</label>
        <ckeditor v-model="comment" :editor="editor" :class="{'is-invalid': v$.comment.$error}"></ckeditor>
        <p
            v-for="error of v$.comment.$errors"
            :key="error.$uid"
            class="invalid-feedback"
        >
          {{error.$message}}
        </p>
        <div v-for="(error, index) in customerErrors" :key="index" style="color: #D13704;">
          {{error.message}}
        </div>
        <div class="mt-3 col-12">
          <b-button variant="info" size="lg" class="py-2 text-white w-100" disabled v-if="customerLoading">
            <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
            Loading
          </b-button>
          <b-button variant="info" size="lg" class="py-2 text-white w-100 text-white" type="submit" v-else>
            Add Comment
          </b-button>
        </div>
      </form>
    </div>
    <div class="col-sm-6">
      <div v-for="comment in comments" :key="comment.publicId">
        <div class="d-flex mt-3 border-bottom">
<!--          <div class="avatar-xs me-3 mr-3">-->
<!--                  <span-->
<!--                      class="avatar-title bg-soft bg-primary text-primary rounded-circle font-size-16"-->
<!--                  >N</span-->
<!--                  >-->
<!--          </div>-->
          <div class="flex-grow-1">
            <h5 class="mt-0 font-size-15">{{comment.lastUpdatedBy.name}}</h5>
            <p class="text-muted" v-html="comment.comment"></p>
            <div class="text-muted">
              <i class="far fa-calendar-alt text-primary me-1"></i> {{formatDate(comment.createdAt)}}
            </div>
          </div>
        </div>
        <hr/>
      </div>
    </div>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "@ckeditor/ckeditor5-vue";
import {required} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import moment from "moment"
import {mapActions, mapGetters} from "vuex";
import {successToast} from "@/components/successToast";
import {permissions} from "@/router/permissions";

export default {
name: "comments",
  components: {ckeditor: CKEditor.component},
  setup () {
    return { v$: useVuelidate() }
  },
  data(){
    return{
      comment: "",
      editor: ClassicEditor,
      add_sales_profile_comment_permission: permissions.add_sales_profile_comment_permission,
    }
  },
  validations () {
    return {
      comment: {required},
    }
  },
  computed: {
    ... mapGetters({
      customerLoading: 'customers/customerLoading',
      customerErrors: 'customers/customerErrors'
    }),
  },
  props: {
    comments : {
      type: Array,
    }
  },
  methods: {
    ... mapActions({
      addNewComment: 'customers/addNewSalesProfileComment',
    }),
    formatDate(date){
      return moment(date).format('DD MMM, YYYY')
    },
    async addComment() {
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      const data = {
        feedbackPublicId: this.$route.params.id,
        comment: this.comment,
      }
      await this.addNewComment(data).then(resp => {
        this.$emit('updateProfile')
        if(resp.publicId){
          successToast(`New Comment added successfully`)
        }
      })

      this.v$.$touch();
    }
  }
}
</script>

<style scoped>

</style>
